
import { useState, useEffect } from 'react';
import { Row, Col, Button, Image, Container } from 'react-bootstrap';
import { Parser } from 'html-to-react';
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ContextAPI } from '../../ContextAPI/ContextAPI';
import ReactPlayer from 'react-player';
import { Helmet } from 'react-helmet';
import './read.css'

const Read = ({ Cards }) => {

    const { data } = ContextAPI();
    const [Card, setCard] = useState(null);
    const [loading, setLoading] = useState(true);
    const { slug } = useParams();
    const location = useLocation();
    const navigate = useNavigate()

    const defaultTags = [
        'Green Hydrogen',
        'Green Ammonia',
        'National Hydrogen Policy',
        'Renewable Energy',
        'Solar Energy',
        'Zero Emission',
        'Energy Transition',
        'Decarbonization',
        'Renewable Purchase Obligation',
        'Narendra Modi',
        'COP Summit',
    ];
    const latestPosts = data
        .sort((a, b) => new Date(b.date) - new Date(a.date)) // Assuming 'date' is a field in your blog data
        .slice(0, 10);

    const createSlug = (header) => {
        return header
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
            .replace(/\s+/g, '-') // Replace spaces with hyphens
            .replace(/-+/g, '-') // Remove consecutive hyphens
            .trim();
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname])

    useEffect(() => {
        const fetchCardData = async () => {
            try {
                setLoading(true);
                // Clear previous data
                localStorage.removeItem('CardData');

                // First try to get all blogs
                const response = await axios.get('https://gautamsolar.us/admin/news?NoOfNews=100&Page=1');
                const allBlogs = response.data.data;

                // Find the blog post that matches the current slug
                const currentBlog = allBlogs.find(blog => {
                    const blogSlug = blog.Header.toLowerCase()
                        .replace(/[^a-z0-9\s-]/g, '')
                        .replace(/\s+/g, '-')
                        .replace(/-+/g, '-')
                        .trim();
                    return blogSlug === slug;
                });

                if (currentBlog) {
                    setCard(currentBlog);
                    localStorage.setItem('CardData', JSON.stringify(currentBlog));
                }
            } catch (error) {
                console.error('Error fetching post data:', error);
            } finally {
                setLoading(false);
            }
        };

        // Always fetch new data when the URL changes
        fetchCardData();

    }, [slug, location.pathname]);

const cleanHtml = (html) => {
  return html
    .replace(/<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>/gi, "")
    .replace(/<p><\/p>/gi, "");
};

const tags = Card && Card.Tags
    ? (typeof Card.Tags === 'string' ? JSON.parse(Card.Tags) : Card.Tags)
    : defaultTags;

const renderHtmlContent = () => {
    if (!Card || !Card.Body) return null;

    try {
        const parser = new Parser();
        return parser.parse(Card.Body);
    } catch (error) {
        return (
            <div dangerouslySetInnerHTML={{ __html:cleanHtml(Card.Body )}} />
        );
    }
};

if (loading) {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
}

if (!Card) {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh",
                textAlign: "center",
                backgroundColor: "#f5f5f5",
            }}
        >
            <div
                style={{
                    padding: "30px",
                    borderRadius: "10px",
                }}
            >
                <h1 style={{ fontSize: "48px", margin: "0 0 10px 0" }}>404</h1>
                <p style={{ fontSize: "18px", color: "#555", marginBottom: "20px" }}>
                    Page not found
                </p>

                <button
                    onClick={() => navigate('/')}
                    style={{
                        padding: "8px 16px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        backgroundColor: "#a20000",
                        color: "white",
                    }}
                >
                    Go Back
                </button>
            </div>
        </div>
    );
}
const formatDate = (dateStr) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateStr).toLocaleDateString('en-US', options);
};

return (
    <>
        <Helmet>
            <title>{Card?.Header} | Gautam Solar Blog</title>
            <meta
                name="description"
                content={
                    `Read ${Card?.Header} on Gautam Solar blog. Explore insights, updates, and knowledge about solar energy, technology, and innovations.`
                }
            />

            <link
                rel="canonical"
                href={`https://gautamsolar.com/blog/${createSlug(Card?.Header)}`}
            />

            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "BlogPosting",
                    headline: Card?.Header,
                    description: `Read ${Card?.Header} on Gautam Solar blog.`,
                    image: Card?.Image,
                    author: {
                        "@type": "Person",
                        name: "Gautam Solar",
                    },
                    publisher: {
                        "@type": "Organization",
                        name: "Gautam Solar",
                        logo: {
                            "@type": "ImageObject",
                            url: "https://gautamsolar.com/logo-192.png",
                        },
                    },
                    mainEntityOfPage: {
                        "@type": "WebPage",
                        "@id": `https://gautamsolar.com/blog/${createSlug(Card?.Header)}`,
                    },
                    datePublished: Card?.createdOn
                })}
            </script>
        </Helmet>

        <h1 className='visually-hidden'>{Card?.Header}||Gautam Blog</h1>

        <section className='py-5 container'>
            <div style={{ padding: "10px" }}>
                <Row className="justify-content-center" style={{ display: "flex", gap: "7px" }}>
                    <Col lg={8} style={{ padding: '30px', border: '1px solid grey' }}>
                        <div className="mb-4">
                            <Button style={{ border: '2px solid #a20000', backgroundColor: '#a20000', color: 'white', padding: '8px', fontSize: 'large' }}>
                                {Card.Header || ""}
                            </Button>
                            <p> {formatDate(Card.CreatedOn)} <span className="elementor-post-date">{Card.Description}</span> Published By: GautamSolar</p>
                        </div>
                        {Card.ImageURL && (
                            <Image src={Card.ImageURL} alt={Card.Header} fluid className="mb-4" />
                        )}
                        {Card.VideoUrl && (
                            <ReactPlayer
                                url={Card.VideoUrl}
                                controls
                                width="100%"
                                height="auto"
                                className="mb-4"
                            />
                        )}
                        <div className="blog-content mb-4">
                            {renderHtmlContent()}
                        </div>
                        <Container>
                            <h2 className="text-left mb-4" style={{ fontSize: '24px' }}>Tags</h2>
                            <Row xs={1} sm={2} md={3}>
                                {tags.map((tagItem, index) => {
                                    // Determine if tagItem is a string or an object
                                    const tagText = typeof tagItem === 'string' ? tagItem : tagItem.tag;
                                    const tagLink = typeof tagItem === 'object' && tagItem.link ? tagItem.link : null;

                                    return (
                                        <Col key={index} className="mb-3">
                                            <Button
                                                className="tag"
                                                style={{
                                                    backgroundColor: '#a20000',
                                                    margin: '5px',
                                                    width: '100%',
                                                    height: '40px',
                                                    padding: '0 15px',
                                                    lineHeight: '40px'
                                                }}
                                                onClick={() => tagLink && window.open(tagLink, '_blank')}
                                            >
                                                {tagText}
                                            </Button>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Container>
                    </Col>

                    <Col lg={3} style={{ padding: '30px', border: '1px solid grey', maxWidth: "100%", height: "100%" }}>

                        <h2 className="mb-4" style={{ fontSize: '24px' }}>Recent Posts</h2>
                        {latestPosts.map((post, index) => {
                            const postSlug = post.Header.toLowerCase()
                                .replace(/[^a-z0-9\s-]/g, '')
                                .replace(/\s+/g, '-')
                                .replace(/-+/g, '-')
                                .trim();

                            return (
                                <div key={index} className="recent-post">
                                    <Link to={`/${postSlug}`} style={{ textDecoration: 'none', color: '#a20000' }}>
                                        <h5 style={{ marginTop: '10px', fontSize: '15px' }}>{post.Header}</h5>
                                        <Image
                                            src={post.ImageURL}
                                            alt={post.Header}
                                            fluid
                                            className="mb-4"
                                            style={{ width: '100%', maxHeight: '150px', objectFit: 'cover', borderRadius: '5px' }}
                                        />

                                    </Link>
                                </div>
                            );
                        })}
                    </Col>
                </Row>
            </div>
        </section>

        <style>
            {`
                    .blog-content {
                        font-size: 16px;
                        line-height: 1.6;
                        color: #333;
                    }
                    .blog-content p {
                        margin-bottom: 1rem;
                    }
                    .blog-content img {
                        max-width: 100%;
                        height: auto;
                        margin: 1rem 0;
                    }
                `}
        </style>
    </>
);
};

export default Read;

